// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1266":"7f397b8501d01cf4","1978":"6b7e999589bf02f2","2297":"263c139de0bc1b51","2403":"9b1e991129bb4c48","8974":"430dd70d3f10979d"}[chunkId] + ".js";
};